import { ventCapSchema } from '@si/types';
import { get, objectToQueryParams } from '@si/utils';
import { useQuery } from '@tanstack/react-query';
import { z } from 'zod';

import { queryKeys } from './queryKeys';

const responseSchema = z.array(ventCapSchema);

interface Params {
  projectId: string;
  installationId?: string;
  enabled?: boolean;
  noRetry?: boolean;
}

export function useVentCaps({
  projectId,
  installationId,
  enabled = true,
  noRetry = false,
}: Params) {
  const url = `/api/projects/${projectId}/ventcaps${objectToQueryParams({
    installationId,
  })}`;

  const { data, error, isLoading, refetch, isFetching } = useQuery({
    queryKey: queryKeys.getVentCaps(projectId, installationId),
    queryFn: () => get({ url, schema: responseSchema }),
    enabled: !!enabled && !!projectId,
    retry: !noRetry,
  });

  return {
    ventCaps: data ?? [],
    error,
    isLoading,
    isFetching,
    refetch,
  };
}
